module.exports = __webpack_public_path__ + "img/img_whenIsUseful1.71b1ca87.svg";